import type { LucideIcon } from 'lucide-react';
import {
  AlertTriangle,
  BeakerIcon,
  CoinsIcon,
  FlaskConical,
  LayoutDashboard,
  MessageCircle,
  Rocket,
  Settings,
  Target,
  Users,
} from 'lucide-react';

export type NavSection = 'overview' | 'people' | 'studio' | 'settings';

export interface NavItem {
  path: string;
  label: string;
  icon: LucideIcon;
  /** 모바일에서 접근 허용 여부 (docs/specs/superadmin.md §3.3) */
  mobileAllowed: boolean;
}

export interface NavGroup {
  section: NavSection;
  heading: string;
  items: NavItem[];
}

/**
 * 사이드바 네비게이션 구조 (docs/specs/superadmin.md §2).
 * 4섹션 · 10페이지.
 */
export const NAV_GROUPS: readonly NavGroup[] = [
  {
    section: 'overview',
    heading: '개요',
    items: [
      {
        path: '/overview/dashboard',
        label: '대시보드',
        icon: LayoutDashboard,
        mobileAllowed: true,
      },
    ],
  },
  {
    section: 'people',
    heading: '사용자',
    items: [
      { path: '/people/members', label: '회원', icon: Users, mobileAllowed: true },
      { path: '/people/credits', label: '크레딧', icon: CoinsIcon, mobileAllowed: true },
      { path: '/people/feedback', label: '피드백', icon: MessageCircle, mobileAllowed: true },
    ],
  },
  {
    section: 'studio',
    heading: 'AI 스튜디오',
    items: [
      { path: '/studio/lab', label: '실험실', icon: FlaskConical, mobileAllowed: false },
      { path: '/studio/treatments', label: '시술 카탈로그', icon: BeakerIcon, mobileAllowed: false },
      { path: '/studio/experiments', label: '실험 · 롤아웃', icon: Rocket, mobileAllowed: false },
      { path: '/studio/golden-set', label: '골든 세트', icon: Target, mobileAllowed: false },
      {
        path: '/studio/incidents',
        label: '인시던트',
        icon: AlertTriangle,
        mobileAllowed: true,
      },
    ],
  },
  {
    section: 'settings',
    heading: '설정',
    items: [
      { path: '/settings', label: '설정', icon: Settings, mobileAllowed: false },
    ],
  },
] as const;

/** 경로로 NavItem 조회 */
export function findNavItem(pathname: string): NavItem | undefined {
  for (const group of NAV_GROUPS) {
    for (const item of group.items) {
      if (pathname === item.path || pathname.startsWith(`${item.path}/`)) {
        return item;
      }
    }
  }
  return undefined;
}
